"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
Entry.TvCast = /*#__PURE__*/function () {
  function TvCast(tvCast) {
    (0, _classCallCheck2["default"])(this, TvCast);
    this.generateView(tvCast);
  }
  return (0, _createClass2["default"])(TvCast, [{
    key: "init",
    value: function init(tvCastHash) {
      this.tvCastHash = tvCastHash;
    }
  }, {
    key: "generateView",
    value: function generateView(tvCastHash) {
      var movieContainer = Entry.createElement('div');
      movieContainer.addClass('entryContainerMovieWorkspace');
      movieContainer.addClass('entryRemove');
      var iframe = Entry.createElement('iframe');
      iframe.setAttribute('id', 'tvCastIframe');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('frameborder', 0);
      iframe.setAttribute('src', tvCastHash);
      this.movieFrame = iframe;
      movieContainer.appendChild(this.movieFrame);
      this.movieContainer = movieContainer;
    }
  }, {
    key: "getView",
    value: function getView() {
      return this.movieContainer;
    }
  }, {
    key: "resize",
    value: function resize() {
      var iframe = document.getElementById('tvCastIframe');
      var w = this.movieContainer.offsetWidth;
      iframe.width = "".concat(w, "px");
      iframe.height = "".concat(w * 9 / 16, "px");
    }
  }]);
}();